export const clearQueryKey: (key: string) => void = (key) =>
  window.history.replaceState(
    {},
    document.title,
    window.location.href.replace(new RegExp(`[?&]${key}=[^&]*`), '')
  )
